var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgLocationValue = function SvgLocationValue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h22v22H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.008 3.727.122.096v1.02l-.072.096a7.319 7.319 0 1 0 8.933 9.24l.07-.237.095-.072h1.02l.097.122A8.505 8.505 0 0 1 1.5 11.989a8.519 8.519 0 0 1 6.25-8.195l.258-.067zM10.01 1.5c5.79.006 10.483 4.699 10.489 10.49a.594.594 0 0 1-.5.586l-.094.007H10.01a.594.594 0 0 1-.586-.5l-.007-.093V2.094a.594.594 0 0 1 .5-.587l.094-.007zm.593 1.206v8.69h8.689l-.01-.159a9.318 9.318 0 0 0-8.52-8.52l-.159-.01z",
    fill: "#000",
    fillRule: "nonzero"
  }))));
};

export default SvgLocationValue;